module.exports = __webpack_public_path__ + "img/banner-12-3@2x.b362e61c.jpg";